<template>
  <div>
    <page-content-toolbar
      projectName=""
      :title="$t('accountsAndBilling.accountManagement')"
    >
      <v-btn
        @click="addAccount"
        class="float-right caption font-weight-medium mr-4"
        outlined
        tile
        color="primary"
      >
        {{ $t('accountsAndBilling.createAccount') }}
      </v-btn>
    </page-content-toolbar>

    <div class="ma-8">
      <v-data-table
        :headers="headers"
        :items="accounts"
        :options.sync="options"
        :server-items-length="totalAccounts"
        :loading="loadingAccounts"
        :footer-props="footerProps"
        class="elevation-1 rai-projects-table"
        @click:row="goToBilling($event)"
        :no-data-text="$t('accountsAndBilling.youDontHaveAccess')"
      >
       <template v-slot:item.actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="isUserParameterizer"
                @click.stop="goToAccount(item)"
                class="float-right"
                icon
                color="ternary"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-pencil-outline</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('accountsAndBilling.edit') }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.lastModifiedDate="{ item }">
          {{ new Date(item.lastModifiedDate || item.createdDate).toLocaleDateString($i18n.locale) }}
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import PageContentToolbar from '@/components/layout/PageContentToolbar';
import accountService from '@/services/accounts.js';
import userRightMixin from '@/mixins/user-right-mixin.js';

export default {
  name: 'Accounts',

  components: { PageContentToolbar, },

  mixins: [ userRightMixin ],

  data () {
    return {
      accounts: [],
      totalAccounts: 0,
      loadingAccounts: false,
      options: {},
    };
  },

  computed: {
    headers () {
      return [
        { text: this.$i18n.t('accountsAndBilling.accountName'), value: 'name' },
        { text: this.$i18n.t('global.lastModifiedDate'), value: 'lastModifiedDate' },
        { text: '', value: 'actions', width: '104px', sortable: false },
      ];
    },
    footerProps () {
      return {
        'items-per-page-options': [10, 20, 50, 100],
        'items-per-page-text': this.$i18n.t('global.rowPerPage'),
        'page-text': '{0}-{1} / {2}',
      };
    },
  },

  methods: {
    goToAccount (item) {
      this.$router.push({ name: 'accountDetails', params: { accountId: item.id} });
    },

    goToBilling (item) {
      this.$router.push({ name: 'billing', params: { accountId: item.id} });
    },

    addAccount () {
      this.$router.push({ name: 'newAccount' });
    },

    getAccounts () {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options
      accountService.getAccounts(sortBy, sortDesc, page ? page - 1 : undefined, itemsPerPage).then(res => {
        this.loadingAccounts = true;
        this.accounts = res.data;
        this.totalAccounts = res.data.length;
        // this.accounts = res.data.content;
        // this.totalAccounts = res.data.page.totalElements;
      }).catch(err => {
        this.$emit('raison-event', { type: 'error', messages: [err] });
      }).finally(() => {
        this.loadingAccounts = false;
      })
    },
  },

  created () {
    this.loadingAccounts = true;
    this.getAccounts();
  },

  watch: {
    options: {
      handler () {
        this.getAccounts();
      },
      deep: true,
    },
  },
};
</script>

<style>
.droppable {
  border: dashed 2px grey;
  width: 100%;
  height: 40px;
  text-align: center;
}

.rai-projects-table.v-data-table tr {
  cursor: pointer;
}
</style>
